import { MutationTree } from 'vuex';
import { WeekSchedule, WeekDay, TimeUnit } from '../models/weekScheduleModels';
import { AvailableTicketType } from '../models/formModels';
import { WorkshopsScheduleState } from './types';
import { EventTicket } from '../models/EventRegistration';

export const mutations: MutationTree<WorkshopsScheduleState> = {
    storeLoading(state, loading: boolean) {
        state.loading = loading;
    },
    storeIsGuidelineVisible(state, isGuidelineVisible: boolean) {
        state.isGuidelineVisible = isGuidelineVisible;
    },
    storeEventRegistrationId(state, eventRegistrationId: number) {
        state.eventRegistrationId = eventRegistrationId;
    },
    storeEventRegistrationGuid(state, eventRegistrationGuid: string) {
        state.eventRegistrationGuid = eventRegistrationGuid;
    },
    storeRecommendedBy(state, recommendedBy: string) {
        state.recommendedBy = recommendedBy;
    },
    storeWeekSchedule(state, weekSchedule: WeekSchedule) {
        state.weekSchedule = weekSchedule;
    },
    storeTimelineTitle(state, title: string) {
        state.timeline.Title = title;
    },
    storeTimelineStartTime(state, startTime: string) {
        state.timeline.TimelineStartTime = startTime;
    },
    storeTimelineEndTime(state, endTime: string) {
        state.timeline.TimelineEndTime = endTime;
    },
    storeTimelineTimeUnits(state, timeUnits: TimeUnit[]) {
        state.timeline.TimeUnits = [];
        for (let index = 0; index < timeUnits.length; index++) {
            state.timeline.TimeUnits.splice(index, 1, timeUnits[index]);
        }
    },
    storeWeekDays(state, weekDays: WeekDay[]) {
        for (let index = 0; index < weekDays.length; index++) {
            state.weekSchedule.WeekDays.splice(index, 1, weekDays[index]);
        }
    },
    storeFilteredWeekDays(state, weekDays: WeekDay[]) {
        state.filteredWeekDays = [];
        for (let index = 0; index < weekDays.length; index++) {
            state.filteredWeekDays.splice(index, 1, weekDays[index]);
        }
    },
    selectWorkshops(state, workshopsIds: number[]) {
        workshopsIds.forEach(id => {
            state.selectedWorkshopsIds?.push(id);
        });
    },
    unselectWorkshops(state, workshopsIds: number[]) {
        workshopsIds.forEach(id => {
            state.selectedWorkshopsIds.splice(state.selectedWorkshopsIds.indexOf(id), 1);
        });
    },
    selectTickets(state, ticketsIds: number[]) {
        ticketsIds.forEach(id => {
            state.selsctedTicketsIds?.push(id);
        });
    },
    unselectTickets(state, ticketsIds: number[]) {
        ticketsIds.forEach(id => {
            state.selsctedTicketsIds.splice(state.selsctedTicketsIds.indexOf(id), 1);
        });
    },
    selectTicket(state, ticketId: number) {
        state.selsctedTicketsIds?.push(ticketId);
    },
    unselectTicket(state, ticketId: number) {
        state.selsctedTicketsIds.splice(state.selsctedTicketsIds.indexOf(ticketId), 1);
    },
    storeAvailableTicketTypes(state, availableTicketTypes: AvailableTicketType[]) {
        state.availableTicketTypes.splice(0, state.availableTicketTypes.length);
        for (let index = 0; index < availableTicketTypes.length; index++) {
            state.availableTicketTypes.splice(index, 1, availableTicketTypes[index]);
        }
    },
    storeEventTickets(state, eventTickets: EventTicket[]) {
        state.eventTickets = eventTickets;
    },
};
